<template>
    <div>
        <div>
            <span class="color1" v-if="buttons.indexOf('30014001003')!='-1'&&(row.state==1 || row.state==2) && row.sort==0" @click="operateType='top';operateMatter()">置顶</span>
            <span class="color1" v-if="buttons.indexOf('30014001002')!='-1'&&(row.state==1 || row.state==2) && row.sort!=0" @click="operateType='untop';operateMatter()">取消置顶</span>
            <span class="color1" @click="previewFlag=true;">预览</span>
            <router-link  v-if="buttons.indexOf('30014001004')!='-1'&&row.state==0" :to="{path:'/matterManage/matter_created',query:{id:row.materialId}}">
                <span class="editBtn">编辑</span>
            </router-link>
            <span class="color2" v-if="buttons.indexOf('30014001006')!='-1'&&(row.state==1 || row.state==2)" @click="operateType='revoke';operateFlag=true">撤回</span>
            <span class="delBtn" v-if="buttons.indexOf('30014001005')!='-1'&&row.state==0" @click="operateType='delete';operateFlag=true">删除</span>
        </div>
        <Modal v-model="previewFlag" title="内容预览" class="publicModel deleteInputBtn" width='375'>
            <previewMatter v-if="previewFlag" :row='row'></previewMatter>
        </Modal>
        <Modal v-model="operateFlag" title="确定" class="publicModel" width='400' @on-ok='operateMatter'>
            <div class="publicHint">
                <p v-if="operateType=='revoke'">确定撤回该内容？</p>
                <p v-if="operateType=='delete'">确定删除该素材？</p>
            </div>
        </Modal>
    </div>
</template>
<script>
    import previewMatter from "./previewMatter"
    import matterManageApi from "@/api/matterManage";
    export default {
        props: ["row"],
        data() {
            return {
                previewFlag:false,/* 预览开关 */
                operateType: '',/* 操作的类型 top--置顶   untop--取消置顶   revoke--撤回   delete--删除 */
                operateFlag:false,/* 二次确认的弹框 */
                buttons:sessionStorage.getItem('menu'),/* 权限的按钮 */
            }
        },
        methods: {
            operateMatter(){/* 撤销 */
                matterManageApi[this.operateType](this.row.materialId).then(res=>{
                    if(res.data.code=='200'){
                        this.$Message.success('操作成功')
                        this.$emit('showMaterialsByCondition')
                    }else{
                        this.$Message.error(res.data.message)
                    }
                })
            },
        },
        components:{
            previewMatter
        }
    }
</script>
<style scoped>
    .color1 {
        margin: 0 5px;
        cursor: pointer;
        color: #6236FF;
    }
    .color2 {
        margin: 0 5px;
        cursor: pointer;
        color: #f59a23;
    }
    .color3 {
        margin: 0 5px;
        cursor: pointer;
        color: #ff0000;
    }
</style>